import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';
import { LocalGame } from '../game/LocalGame';
import {
  flagsOf,
  mountainFromParams,
  mountainKey,
  mountainParams,
  randomSeed,
  toggleExperiment,
  type Mountain,
} from '../game/mountain';
import { createLocalGameStore } from '../game/store';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

/** The v0.1 mountain game, two players on one screen. The mountain lives in the URL so a refresh keeps it. */
export function PlayLocal() {
  const [params, setParams] = useSearchParams();
  const mountain = mountainFromParams(params);
  useDocumentTitle('Local game');

  useEffect(() => {
    if (!mountain)
      setParams(mountainParams({ kind: 'seed', seed: randomSeed() }), { replace: true });
  }, [mountain, setParams]);

  if (!mountain) return null;
  return (
    <LocalGameRoute
      key={mountainKey(mountain)}
      mountain={mountain}
      onMountain={(next) => setParams(mountainParams(next))}
    />
  );
}

function LocalGameRoute({
  mountain,
  onMountain,
}: {
  mountain: Mountain;
  onMountain: (m: Mountain) => void;
}) {
  const [store] = useState(() => createLocalGameStore(mountain));
  return (
    <LocalGame
      store={store}
      onToggleExperiment={(key) => onMountain(toggleExperiment(mountain, key))}
      onNewMountain={() => onMountain({ ...flagsOf(mountain), kind: 'seed', seed: randomSeed() })}
      onClassic={() =>
        mountain.kind === 'classic'
          ? store.getState().start(mountain)
          : onMountain({ ...flagsOf(mountain), kind: 'classic' })
      }
    />
  );
}
